export default [
  {
    path: '/',
    redirect: '/test-drive',
  },

  {
    path: '/demo3d',
    component: () => import('../../views/3d/demo3d.vue'),
    name: '',
    hidden: true,
    meta: {
      auth: 0,
    },
  },
  {
    path: '/demo2',
    component: () => import('../../views/3d/demo2.vue'),
    name: '',
    hidden: true,
    meta: {
      auth: 0,
    },
  },
  {
    path: '/problem',
    name: 'problem',
    hidden: true,
    component: () => import('../../views/home/Problem.vue'),
    meta: {
      auth: 0,
    },
  },
  {
    path: '/edition',
    component: () => import('../../views/sharePage/edition.vue'),
    name: '',
    hidden: true,
    meta: {
      auth: 0,
    },
  },
  {
    path: '/selectColor',
    component: () => import('../../views/sharePage/selectColor.vue'),
    name: '',
    hidden: true,
    meta: {
      auth: 0,
    },
  },
  {
    path: '/orderDetailPeriphery',
    component: () => import('../../views/sharePage/orderDetailPeriphery.vue'),
    name: '',
    hidden: true,
    meta: {
      auth: 0,
    },
  },
  {
    path: '/orderDetailCar',
    component: () => import('../../views/sharePage/orderDetailCar.vue'),
    name: 'orderDetailCar',
    hidden: true,
    meta: {
      auth: 0,
    },
  },
  {
    path: '/commodityDetails',
    component: () => import('../../views/sharePage/commodityDetails.vue'),
    name: 'commodityDetails',
    hidden: true,
    meta: {
      auth: 0,
    },
  },
  {
    path: '/post',
    component: () => import('../../views/sharePage/post.vue'),
    name: 'post',
    hidden: true,
    meta: {
      auth: 0,
    },
  },
  {
    path: '/richTextPost',
    component: () => import('../../views/sharePage/richTextPost.vue'),
    name: 'richTextPost',
    hidden: true,
    meta: {
      auth: 0,
    },
  },
  {
    path: '/richTextPostWin',
    component: () => import('../../views/sharePage/richTextPostWin.vue'),
    name: 'richTextPostWin',
    hidden: true,
    meta: {
      auth: 0,
    },
  },
  {
    path: '/activityPost',
    component: () => import('../../views/sharePage/activityPost.vue'),
    name: 'activityPost',
    hidden: true,
    meta: {
      auth: 0,
    },
  },
  {
    path: '/onOfflineActivity',
    component: () => import('../../views/sharePage/onOfflineActivity.vue'),
    name: 'onOfflineActivity',
    hidden: true,
    meta: { auth: 0, backgroundClass: 'onOfflineActivityClass' },
  },
  {
    path: '/votePost',
    component: () => import('../../views/sharePage/votePost.vue'),
    name: 'votePost',
    hidden: true,
    meta: {
      auth: 0,
    },
  },
  {
    path: '/trajectory',
    component: () => import('../../views/sharePage/trajectory.vue'),
    name: 'trajectory',
    hidden: true,
    meta: {
      auth: 0,
    },
  },

  {
    path: '/download',
    component: () => import('../../views/sharePage/Download.vue'),
    name: 'download',
    hidden: true,
    meta: { auth: 0, backgroundClass: 'bg-gray' },
  },
  {
    path: '/download-acc',
    component: () => import('../../views/sharePage/DownloadVicc.vue'),
    name: 'download-acc',
    hidden: true,
    meta: {
      auth: 0,
      title: 'NFC打开APP',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/download-vicc',
    component: () => import('../../views/sharePage/DownloadVicc.vue'),
    name: 'download-vicc',
    hidden: true,
    meta: {
      auth: 0,
      title: 'NFC打开APP',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/personalCenter',
    component: () => import('../../views/sharePage/personalCenter.vue'),
    name: 'personalCenter',
    hidden: true,
    meta: { auth: 0, backgroundClass: 'bg-gray' },
  },
  {
    path: '/x',
    component: () => import('../../views/sharePage/x.vue'),
    name: 'x',
    hidden: true,
    meta: {
      auth: 0,
    },
  },
  {
    path: '/other',
    component: () => import('../../views/sharePage/other.vue'),
    name: 'other',
    hidden: true,
    meta: {
      auth: 0,
    },
  },
  {
    path: '/test-drive',
    name: 'test-drive',
    component: () => import('../../views/home/TestDrive.vue'),
    meta: {
      auth: 0,
      title: '预约试驾',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/test-drive2',
    name: 'test-drive2',
    component: () => import('../../views/home/TestDrive2.vue'),
    meta: {
      auth: 0,
      title: '预约试驾',
      backgroundClass: 'bg-gray',
    },
  },
  {
    name: 'test-drive-result',
    path: '/test-drive-result-:id',
    component: () => import('../../views/home/TestDriveResult.vue'),
    meta: {
      auth: 0,
      title: '预约试驾',
      backgroundClass: 'bg-gray',
    },
  },
  {
    name: 'detail',
    path: '/detail-:productId',
    component: () => import('../../views/home/Detail.vue'),
    meta: {
      auth: 0,
      title: '商品详情',
    },
  },
  {
    name: 'test-drive-detail',
    path: '/test-drive-detail-:vehicleTypeId',
    component: () => import('../../views/home/TestDriveDetail.vue'),
    meta: {
      auth: 0,
      title: '预约试驾车型详情',
      backgroundClass: 'bg-gray',
    },
  },
  {
    name: 'agreement',
    path: '/agreement',
    component: () => import('../../views/agreement/agreement.vue'),
    meta: {
      auth: 0,
      title: '协议',
      backgroundClass: 'bg-gray',
    },
  },
  {
    name: 'community-norm',
    path: '/community-norm',
    component: () => import('../../views/agreement/CommunityNorm.vue'),
    meta: {
      auth: 0,
      title: 'ZEEHO APP社区规范',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/test-drive-list',
    name: 'test-drive-list',
    component: () => import('../../views/testDrive/TestDriveList.vue'),
    meta: {
      auth: 0,
      title: '我的试驾列表',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/test-drive-remarks',
    name: 'test-drive-remarks',
    component: () => import('../../views/testDrive/TestDriveRemarks.vue'),
    meta: {
      auth: 0,
      title: '我的试驾评价',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/test-drive-rating',
    name: 'test-drive-rating',
    component: () => import('../../views/testDrive/TestDriveRating.vue'),
    meta: {
      auth: 0,
      title: '',
      backgroundClass: 'bg-gray',
      keepAlive: true,
    },
  },
  {
    path: '/receiving-address',
    name: 'receiving-address',
    component: () => import('../../views/testDrive/addressList/ReceivingAddress.vue'),
    meta: {
      auth: 0,
      title: '收货地址',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/add-receiving-address',
    name: 'add-receiving-address',
    component: () => import('../../views/testDrive/addressList/AddReceivingAddress.vue'),
    meta: {
      auth: 0,
      title: '新增地址',
      backgroundClass: 'bg-gray',
    },
  },

  {
    path: '/webview',
    component: () => import('../../views/home/Webview.vue'),
    name: 'webview',
    hidden: true,
    meta: {
      auth: 0,
    },
  },
];
